export default{
    methods:{
        handleMouseMoveForStoryBoardPreview(event,file){
            if(this.getFileMimeType(file) != 'video') return;
            if(!this.storyboardPreviewActiveId){
                this.storyboardPreviewActiveId = file._id;
            }else{
              if(this.storyboardPreviewActiveId != file._id){
                 this.storyboardPreviewActiveId = file._id; 
              }
            }
            const containerRect = event.target.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            let percentage = (mouseX/containerRect.width) * 100;
            this.$nextTick(()=>{
                if(this.$refs['storyboard'+file._id]){
                    this.$refs['storyboard'+file._id][0].showImageOnHover(percentage);
                }
            });
       },

        calculateLeftOverTTLDays(ttlDate) {
            const today = new Date(); // Get today's date
            const targetDate = new Date(ttlDate); // Convert the target date string to a Date object
            
            const timeDifference = targetDate - today; // Get the difference in milliseconds
            
            // Convert milliseconds to days (1 day = 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
            return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
        },
    }
}